/**
 * @generated SignedSource<<8bcb02d2fd0965d158bcfaadce5d5e73>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StartLessonSetInput = {
  lessonSetId: string;
};
export type LessonTodayCardStartMutation$variables = {
  input: StartLessonSetInput;
};
export type LessonTodayCardStartMutation$data = {
  readonly startLessonSet: {
    readonly id: string;
  };
};
export type LessonTodayCardStartMutation = {
  response: LessonTodayCardStartMutation$data;
  variables: LessonTodayCardStartMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LessonSet",
    "kind": "LinkedField",
    "name": "startLessonSet",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LessonTodayCardStartMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "LessonTodayCardStartMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "58b264b2170cd17436f8e247dfa8f604",
    "id": null,
    "metadata": {},
    "name": "LessonTodayCardStartMutation",
    "operationKind": "mutation",
    "text": "mutation LessonTodayCardStartMutation(\n  $input: StartLessonSetInput!\n) {\n  startLessonSet(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8dbc225c5c6f728ff673401fe9efd6ca";

export default node;
